import { IconTooltip } from '../../pages/dashboard/dashboardHelper';
import styles from './iconsDock.module.css';
import { IconDock, IconDockProps } from './iconsDock.types';

const IconsDock = (props: IconDockProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.dock1}>
        {props.icons.dock1.map((icon: IconDock, index) =>
          icon.hide ? null : (
            <button
              className={`${styles.icon} ${icon.disabled && styles.disabled}`}
              key={index}
              onClick={icon.onClick}
            >
              {icon.icon}
              {icon.label && (
                <IconTooltip text={icon.label} className={styles.tooltip} />
              )}
            </button>
          ),
        )}
      </div>
      <div className={styles.dock2}>
        {props.icons.dock2.map((icon: IconDock, index) =>
          icon.hide ? null : (
            <button
              className={`${styles.icon} ${icon.disabled && styles.disabled}`}
              key={index}
              onClick={icon.onClick}
            >
              {icon.icon}
              {icon.label && (
                <IconTooltip text={icon.label} className={styles.tooltip} />
              )}
            </button>
          ),
        )}
      </div>
    </div>
  );
};

export default IconsDock;
